import Player from './player';
import Action from 'actions';
import {toFloat} from "helpers/number-helper";

export default class PlayerTiers extends Player {
    getExpandedEntityParams({incomingValues = {}}) {
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});

        return {
            ...expandedPlayer,
            salary: 0,
            sharpPoints: toFloat(expandedPlayer.sharpPoints ?? 0, 3),
            isExcludedBySalary: () => false,
            isFitForLineup(substitutablePlayer) {
                return substitutablePlayer.rosterPositionName === this.rosterPositionName;
            },
        };
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('playerNameStacking')) {
            dispatch(Action.set('PlayerNameStackingFromStorage', data.playerNameStacking));
        }
    }
}
